import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material';

export const StyledSelectArrow = styled(KeyboardArrowDownIcon, {
	shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ isOpen }: { isOpen: boolean }) => ({
	transition: 'all .3s',
	transform: isOpen ? 'rotate(180deg)' : undefined,
	fontSize: '16px',
}));
